module.exports = __webpack_public_path__ + "static/media/Bot4.3a48dca0.jpeg";